/* eslint-disable prettier/prettier */
export default {
	// 共通
	//  ＴＯＰ／ヘッダ
	'ホーム': 'Home',
	'サイドメニューより操作項目を選択してください': 'Select item from the side menu',
	'ログアウト': 'Logout',
	'公開店舗/学校/病院数': 'Number of Public',
	'非公開店舗/学校/病院数': 'Number of Private',
	'センサー総数': 'Total Number of Sensors',
	'表示言語': '言語/langage',
	'加入店舗数取得時にエラーが発生しました': 'An unexpected error has occurred. Issues with acquisition of the number of registered stores.',
	'選択中のリセラー情報': 'Selected reseller information',
	//  メニュー
	'リセラー情報管理': 'Reseller information management',
	'グループ情報管理': 'Group Data Management',
	'店舗/学校/病院情報管理': 'Store, School, Hospital Management',
	'店舗/学校/病院確認一覧': 'Store, School, Hospital List',
	'センサー管理': 'Sensor Management',
	'センサーデータダウンロード': 'Sensor Data Download',
	'セキュリティ情報管理': 'Security Data Management',
	'グラフ埋め込み用HTML出力': 'HTML output of Embedded chart',
	'ユーザー情報管理': 'User Data Management',
	'マニュアル/FAQ': 'Manual & FAQ',
	'利用規約': 'Terms of Service',
	'メニューの取得に失敗しました': 'Failed to retrieve data.',
	'再読み込み': 'Reload',
	//  グループ情報管理.一覧
	'新規登録': 'Registration ',
	'編集': 'Edit',
	'削除': 'Delete',
	'グループID': 'Group ID',
	'グループ名': 'Group Name',
	'グループ管理者の会社名': 'Company Name of Group Account Holder ',
	'{groupName}を削除します。よろしいですか？': 'Are you sure you want to delete "{groupName}"?',
	'グループ情報が削除されました。': 'Deleted',
	'本機能を利用する権限がありません': 'You are not authorized.',
	'施設情報取得時にエラーが発生しました': 'An unexpected error has occurred. Issues with property data acquisition.',
	//  グループ情報管理.詳細
	'グループ情報の登録': 'Group Data Registration',
	'グループ情報の更新': 'Group Data Update / Data Update',
	
	
	'必須項目です。140文字以内で入力してください。': 'Required field. Enter 140 characters or less.',
	'グループ名（英語表記）': 'Group Name (English)',
	'必須項目です。半角文字140文字以内で入力してください。': 'Required field. Enter using half-width English numbers and letters, using 140 characters or less.',
	'グループ管理者のメールアドレス': 'Email address of Group Account Holder',
	'必須項目です。EMAILアドレスの書式で、256文字以内で入力してください。': 'Required field. Enter by email address style, using 256 characters or less.',
	
	
	'グループ管理者の会社名（英語表記）': 'Company Name of Group Account Holder (English)',
	
	'グループ管理者のWEBサイトURL': 'URL of Account Holder',
	'必須項目です。512文字以内で入力してください。': 'Required field. Enter 512 characters or less.',
	'副管理者一覧': 'Sub-Account Holder List ',
	'副管理者追加': 'Add sub-account holder ',
	'グループ副管理者のメールアドレス': 'Email address of Sub-Account Holder',
	'グループ共通情報': 'Group Common Data ',
	'以下の公開情報についてサブグループごとに実施有無を入力してください。(実施有無の入力は画面下部のサブグループ一覧にて実施)': 'Enter implemented items for each subgroup to the Public Information below. (Use the Sub-Group List at the bottom of the screen to enter the implemented items) ',
	'公開情報': 'Public Information ',
	'内容': 'Details ',
	'回答番号': 'Answer number ',
	'換気': 'Ventilation',
	'建築基準法の必要換気量を確保しています。（一人当たり30m/時もしくは、床と窓の面積比が５:1程度）': 'Maintain the ventilation volume required under the Building Standards Act (30 ㎥/hour per person, or a floor-area-to-window-area ratio of about 5:1).',
	'換気①': 'Ventilation 1',
	'換気設備の運転状況を確認しています。（または定期的な窓の開放を実施しています）': 'Regularly check the operating status of ventilation equipment and open windows.',
	'換気②': 'Ventilation 2',
	'トイレ消毒': 'Disinfection of Restrooms',
	'トイレ定期清掃・消毒、ドアノブの消毒、消毒液設置をしています': 'Clean and disinfect restrooms regularly and install hand sanitizer stations.',
	'トイレ①': 'Restroom 1',
	'サブグループ一覧': 'Sub-Group List',
	'サブグループ追加': 'Add sub-groups',
	'サブグループID': 'Sub-Group ID',
	'店舗/学校/病院情報表示': 'View Store, School, Hospital Data',
	'表示': 'View',
	'サブグループ名': 'Sub-Group Name',
	'店舗/学校/病院情報管理者のメールアドレス': 'Email address of Account Holder ',
	
	
	
	
	'戻る': 'Backward',
	'登録': 'Registration ',
	'グループ情報が登録されました。店舗/学校/病院情報を登録すると公開されます。': 'Group data has been registered. Store/School/Hospital data will be published on website when registered.',
	'グループ情報が更新されました。': 'Update Successful',
	
	'指定されたグループが管理対象でないため表示できません。': 'You are not authorized.',
	'施設情報詳細取得時にエラーが発生しました': 'An unexpected error has occurred. Issues with property data acquisition.',
	'サブグループ名なし（{xx}行目）を削除します。よろしいですか？': 'Not find the sub-group name. Are you sure you want to delete (row {rowno})?',
	'{サブグループ名}を削除します。よろしいですか？': 'Are you sure you want to delete "{subgroupname}"?',
	'店舗情報削除時にエラーが発生しました': 'An unexpected error has occurred. Issues with property data erasure.',
	'副管理者（{xx}行目）を削除します。よろしいですか？': 'Are you sure you want to delete this sub-account holder( row {rowno})?',
	'{managerEmail}を削除します。よろしいですか？': 'Are you sure you want to delete "{managerEmail}"?',
	'施設の管理者アドレスがユーザ情報に登録されていません。システム管理者にご連絡ください。': 'Couldn\'t find the address. Please contact your system administrator.',
	'施設の管理者アドレスがユーザ情報として2件以上登録されています。システム管理者にご連絡ください。': 'Two or more addresses exist. Please contact your system administrator.',
	'店舗の管理者アドレスがユーザ情報として2件以上登録されています。システム管理者にご連絡ください。': 'Two or more addresses exist. Please contact your system administrator.',
	'データ登録時にエラーが発生しました。': 'An unexpected error has occurred. Issues with data registration.',
	
	'アラート・レポート管理時間': 'Aleart / Report Administration Time',	
	'設定する': 'Enable',	
	'設定しない': 'Disable',	
	'開始': 'Start Time',	
	'終了': 'End Time',	
	'sunday': 'Sunday',	
	'monday': 'Monday',	
	'tuesday': 'Tuesday',	
	'wednesday': 'Wednesday',	
	'thursday': 'Thursday',	
	'friday': 'Friday',	
	'saturday': 'Saturday',	
	'のアラート・レポート管理時間（{xx}行目）を削除します。よろしいですか？': 'Are you sure you want to delete this Administration Time( row {rowno})?',
	'除外': 'unabled',	
	'除外日の追加': 'Add Exclusion Date',
	'除外日': 'Exclusion Date',
	'除外日（{xx}行目）を削除します。よろしいですか？': 'Are you sure you want to delete this Exclusion date( row {rowno})?',
	'{exclusionDate}を削除します。よろしいですか？': 'Are you sure you want to delete "{exclusionDate}"?',
	'未入力の項目を埋めてください。': 'Fill in the blank column',	
	'終了時間は、開始時間より後の時間を入力してください。': 'Set End Time after Start Time',	
	'同一曜日内の開始時間・終了時間は重複しないようにしてください。': 'Avoid overlapping Start Time and End Time in the same date of the week',	
	'終了時間は24:00までを入力してください。': 'Set End Time before 24:00',	
	'（{row1}行目）と（{row2}行目）の除外日が重複しています。': 'Exclusion Date of（No. {row1}）and（No. {row2}）are dupulicate entries',
	
	
	
	'データ更新時にエラーが発生しました。': 'An unexpected error has occurred. Issues with data update.',
	
	'施設情報削除時にエラーが発生しました': 'An unexpected error has occurred. Issues with property data erasure.',
	'レポート発行設定': 'Issuing Report Settings',
	'グループ管理者/副管理者に登録されているユーザに「グループレポート」のメールを発行します。': 'Send email on "Group Report" to account holder and sub-account holder. ',
	'発行する': 'Issue',
	'発行しない': 'Not Issue',
	'グループレポートダウンロード': 'Group Report Download',
	'年/月を指定して、過去の「グループレポート」をダウンロードします。': 'Select the date of previous "Group Report" and download.',
	'店舗レポート一括ダウンロード': 'Report Batch Download',
	'年/月を指定して、グループ内の「店舗レポート」を一括ダウンロードします。': 'Select the date of "Reports" of your group and do batch download.',
	'登録される副管理者から利用規約(T*Platsに関する個人情報の取扱い)について同意を確認しました。': 'I have confirmed that the registered sub-administrator has agreed to the terms of use (handling of personal information related to T*Plats).',
	//  店舗/学校/病院情報管理.一覧
	
	
	
	
	
	
	
	'条件クリア': 'Clear Current Criteria',
	
	
	
	'お知らせ設定': 'Notice Settings',
	'店舗/学校/病院名': 'Store, School, Hospital Name',
	
	'お知らせ管理': 'Notice Management',
	
	
	
	
	'アンケート結果': 'Survey Results',
	'取得': 'Get',
	
	'店舗情報取得時にエラーが発生しました': 'An unexpected error has occurred. Issues with property data acquisition.',
	//  店舗/学校/病院情報管理.詳細
	'店舗/学校/病院情報の更新': 'Store, School, Hospital, Room Data Update',
	'公開設定': 'Publish Settings',
	'公開する ': 'Public',
	'非公開にする': 'Private',
	'非公開時URL': 'URL for private',
	'英語版HPあり': 'Japanese and English website',
	'英語版HPなし': 'Japanese version website only ',
	'表示ポータル設定': 'Portal Settings',
	'おみせのトラスト': 'Store',
	'教室のトラスト': 'School',
	'病室のトラスト': 'Hospital',
	
	
	
	
	
	'店舗/学校/病院情報管理者の会社名': 'Company Name of Account Holder ',
	
	'店舗/学校/病院情報管理者の会社名（英語表記）': 'Company Name of Account Holder (English)',
	'半角文字140文字以内で入力してください。': 'Enter using half-width English numbers and letters, using 140 characters or less.',
	
	
	'店舗/学校/病院名（英語表記）': 'Store, School, Hospital Name (English)',
	
	'住所': 'Address',
	
	'住所（英語表記）': 'Address (English)',
	'GoogleMapプレビュー': 'Google Maps preview',
	'GoogleMap preview': 'Google Maps preview',
	'店舗/学校/病院URL（メイン）': 'Main Official Site URL',
	'連携URL1': 'Partner Site URL 1',
	'店舗/学校/病院URL（その他1）': 'Official Site URL 1',
	'連携URL2': 'Partner Site URL 2',
	'店舗/学校/病院URL（その他2）': 'Official Site URL 2',
	'連携URL3': 'Partner Site URL 3',
	'店舗/学校/病院URL（その他3）': 'Official Site URL 3',
	'連携URL4': 'Partner Site URL 4',
	'独自ページ': 'Original Site URL',
	'食べログ': 'Tabelog',
	'ホットペッパー': 'HOTPEPPER',
	'ぐるなび': 'GURUNAVI',
	'コメント（140字以内）': 'Comment (140 characters or less)',
	'140文字以内で入力してください。': 'Enter 140 characters or less.',
	'コメント（140字以内）（英語表記）': 'Comment (140 characters or less) (English)',
	'半角140文字以内で入力してください。': 'Enter using half-width English numbers and letters, using 140 characters or less.',
	
	'管理者追加': 'Add account holder ',
	'店舗/学校/病院情報副管理者のメールアドレス': 'Email address of Sub-Account Holder ',
	
	'アラート通知設定': 'Alert Settings',
	'通知方法': 'Alert Methods',
	
	'実施': 'Done',
	'半角256文字以内で入力してください。': 'Enter using half-width English numbers and letters, using 256 characters or less.',
	'通知しない': 'Never Notify',
	'通知する': 'Notify',
	'メール': 'Email ',
	'管理者と副管理者に登録されているユーザにアラートメールを送信します。': 'Send an alert message to the account holder and sub-account holders.',
	
	
	'SMS': 'SMS',
	'SMSを用いてアラート通知を行います。': 'Use SMS',
	'SMS通知機能は、試用版です。今後、有償オプション化を検討しています。': 'The SMS notification is available only for this demonstration so far. A paid option of the SMS notification is under consideration. ',
	'連絡先追加': 'Add contact information ',
	'アラート通知先電話番号(ハイフンなし)': 'The Phone number of The Alert Recipient (without hyphens)',
	
	
	
	'センサー管理画面へ': 'Go to Sensor Management  page',
	'編集中データは、保存されません。センサー管理画面へ移動しますか？': 'Data cannot be saved while you edit it. Go to Sensor Management  page?',
	'保存する場合は、移動前に画面にて更新ボタンをクリックしてください。': 'If data needs saving, click Update button before leaving this page.',
	'画像情報': 'Details of Image ',
	'アップロードする画像の種類に該当するアイコンを選んでください。': 'Select an icon relevant to the image that you want to upload.',
	'店舗/学校/病院': 'Store, School, Hospital',
	'店舗/学校/病院消毒': 'Store, School, Hospital Disinfection',
	'お客様の安全': 'Customer safety',
	'テーブル間距離/間仕切り': 'Distance between tables',
	'従業員の安全衛生管理': 'Employee safety and health management',
	
	'認証の取得': 'Obtain a certificate',
	'ファイル指定': 'File specification',
	'ファイルを指定してください': 'Specify the file',
	'アップロードできないファイルが指定されています。': 'The file could not be downloaded. Please select another file.',
	'ファイルが指定されていません。': 'No file is specified.',
	'画像区分が選択されていません。': 'Image category has not been selected.',
	'画像区分「店舗/学校/病院」の画像は1つしか登録できません。': 'Only one image can be submitted each category.',
	'画像アップロードに失敗しました。ファイルが破損している可能性があります。ファイルをご確認の上、再度アップロードを実施してください。': 'Upload Failed. The file might be corrupted. Update again after making sure the file function.',
	'※画像アップロード後、更新ボタンを押すことで画像が表示されるようになります。': '*Click Upload to display the uploaded image. ',
	'※10MB以下の、JPG形式、PNG形式ファイルに対応しています。': 'Images that can be saved are JPG or PNG files that are less than 10MB.',
	'画像区分': 'Image Category ',
	'サムネイル': 'Thumbnail',
	'状態': 'State',
	'公開': 'Public',
	'非公開（アップロード済み）': 'Private (uploaded)',
	'アップロード': 'Upload',
	'※画像は3:2で表示されます。縦横比が異なるものは中央部分が表示されます。': '*The image is displayed in 3:2. If the aspect ratio is different, the central part is displayed.',
	'動画情報': 'Details of Video ',
	'動画リンク埋め込み': 'Embedded Movie Link ',
	'512文字以内の半角文字列を入力してください。': 'Enter using half-width English numbers and letters, using 512 characters or less.',
	'※YoutubeのURL [https://www.youtube.com/watch?v=〇〇〇] もしくは、動画ID（〇〇〇の部分のみ）を入力してください。': '*Youtube URL Fill in the fields after https://www.youtube.com/watch?v=',
	'※スペース、および＆は入力できません。': '*Space and & cannot be entered.',
	'店舗/学校/病院信頼性情報': 'Trust Information of Store, School, Hospital',
	
	
	
	
	'換気設備の運転状況を確認、または定期的な窓の開放を実施': 'Regularly check the operating status of ventilation equipment and open windows.',
	'おみせのトラスト：お客様の安全': 'Store: Customer safety ',
	'病室のトラスト：患者様の安全': 'Hospital: Patient safety',
	'教室のトラスト：学校関係者の安全': 'School: Students safety',
	'おみせのトラスト：入口における消毒液を設置、入店時お客様にて消毒実施': 'Store: Provide hand sanitizing stations around entrances and ask people to disinfect their hands upon entering.',
	'病室のトラスト：入口における消毒液を設置、来院時患者様にて消毒実施': 'Hospital: Provide hand sanitizing stations around entrances and ask people to disinfect their hands upon entering.',
	'教室のトラスト：入口における消毒液を設置、登校時学校関係者にて消毒実施': 'School: Provide hand sanitizing stations around entrances and ask students to disinfect their hands upon entering.',
	'おみせのトラスト：入店時お客様に検温を実施': 'Store: Measure the temperature of people upon entering.',
	'病室のトラスト：来院時患者様に検温を実施': 'Hospital: Measure the temperature of people upon entering.',
	'教室のトラスト：登校時学校関係者に検温を実施': 'School: Measure the temperature of students upon entering.',
	'グループ同士で１ｍの間隔が空けられているもしくはパーティションで区切られている': 'Groups are separated by the distance of 1 meter or by partitions.',
	'おみせのトラスト：テーブル間距離': 'Store: Distance between tables',
	'病室のトラスト：テーブル間距離': 'Hospital: Distance between tables',
	'教室のトラスト：机間距離': 'School: Distance between desks',
	'おみせのトラスト：グループ同士で１ｍの間隔が空けられているもしくはパーティションで区切られている': 'Store: Groups are separated by the distance of 1 meter or by partitions.',
	'病室のトラスト：グループ同士で１ｍの間隔が空けられているもしくはパーティションで区切られている': 'Hospital: Groups are separated by the distance of 1 meter or by partitions.',
	'教室のトラスト：隣同士で１ｍの間隔が空けられているもしくはパーティションで区切られている': 'School: Groups are separated by the distance of 1 meter or by partitions.',
	'おみせのトラスト：従業員の安全衛生管理': 'Store: Employee safety and health management',
	'病室のトラスト：病院関係者の安全衛生管理': 'Hospital: Employee safety and health management',
	'教室のトラスト：学校関係者の安全衛生管理': 'School: Faculty and staff health and safety management.',
	'おみせのトラスト：従業員の検温、体調管理を実施': 'Store: Conduct temperature and physical condition checks on employees.',
	'病室のトラスト：病院関係者の検温、体調管理を実施': 'Hospital: Conduct temperature and physical condition checks on employees.',
	'教室のトラスト：学校関係者の検温、体調管理を実施': 'School: Conduct temperature and physical condition checks on faculty and staff.',
	'おみせのトラスト：従業員のマスクまたはフェイスガードの着用': 'Store: Staff wear masks or face guards.',
	'病室のトラスト：病院関係者のマスクまたはフェイスガードの着用': 'Hospital: Staff wear masks or face guards.',
	'教室のトラスト：学校関係者のマスクまたはフェイスガードの着用': 'School: Faculty and staff wear masks or face guards.',
	'おみせのトラスト：店舗消毒': 'Store: Regular Disinfection',
	'病室のトラスト：室内消毒': 'Hospital: Regular Disinfection',
	'教室のトラスト：室内消毒': 'School:Regular Disinfection',
	'おみせのトラスト：ドアノブ、券売機、セルフドリンクコーナーなどのお客様フロアにある設備の消毒': 'Store:Disinfect objects and equipment in customer areas such as doorknobs, ticket machines, and self-serve drink stations.',
	'病室のトラスト：ドアノブ、清算機、待合室などの患者様が使用する設備の消毒': 'Hospital:Disinfect equipment that patients use such as doorknobs, payment machines, waiting rooms, etc.',
	'教室のトラスト：ドアノブ、机、水道の蛇口などの学校関係者が使用する設備の消毒': 'School: Disinfect equipment that students use such as doorknobs, desks and water faucets,etc.',
	'おみせのトラスト：お客様の退席後、テーブル上の消毒もしくはテーブルクロスの交換を実施': 'Store: Disinfect the table or replace the tablecloth after  customers leave. ',
	'病室のトラスト：患者様の退出後、使用した設備の消毒': 'Hospital: Disinfect equipment after patients leave.',
	'教室のトラスト：学校関係者が退出後、使用した設備の消毒': 'School: Disinfect equipment after students leave.',
	'トイレ定期清掃・消毒、消毒液設置を実施': 'Regularly clean and disinfect restrooms, and provide hand sanitizers.',
	//'認証の取得': 'Certified or Uncertified', 重複
	'自治体等の第三者機関が発行する認証店マークを取得': 'Obtaining certification issued by third parties such as a local government as evidence that the facility executes infection prevention/control measures.',
	'部屋一覧': 'Room List',
	'部屋追加': 'Add rooms',
	'部屋ID': 'Room ID',
	'部屋名': 'Room Name',
	'部屋英語名': 'Room Name (English)',
	
	
	'更新': 'Update',
	'店舗/学校/病院情報が更新されました。': 'Update Successful',
	'表示ポータルを選択してください': 'Select a portal site',
	'＆、スペースは入力できません。': '*Space and & cannot be entered.',
	'入力されたURL、もしくは動画IDが正しくありません。': 'URL or movie ID you entered is not correct.',
	
	'店舗の副管理者アドレスがユーザ情報として2件以上登録されています。システム管理者にご連絡ください。': 'Two or more addresses of the sub-account holder exist. Please contact your system administrator.',
	'店舗情報更新時にエラーが発生しました': 'An unexpected error has occurred. Issues with property data update.',
	
	
	'指定された店舗が管理対象店舗でないため表示できません。': 'This property has not been registered. ',
	'店舗情報詳細取得時にエラーが発生しました': 'An unexpected error has occurred. Issues with property data update.',
	
	'画像一覧取得時にエラーが発生しました': 'An unexpected error has occurred. Issues with image data acquisition.',
	
	'画像のサイズが制限値を超えています。': 'The image exceeds the size limit.',
	'画像のファイルサイズが制限値を超えています。': 'The image file exceeds the size limit.',
	'画像アップロード時にエラーが発生しました': 'An unexpected error has occurred. Issues with image upload.',
	'画像アップロードに失敗しました。': 'The image failed to upload.',
	'{FileName}を削除予約します。更新後、この画像は削除されます。': 'Set Deletion Schedule for {FileName}. This file will be deleted after update. ',
	'画像更新(削除予定)時にエラーが発生しました': 'An unexpected error has occurred. Issues with image modification(scheduled delete).',
	'{roomName}（{xx}行目）を削除します。よろしいですか？': 'Are you sure you want to delete "{roomName}" row ({xx})?',
	'部屋（{xx}行目）を削除します。よろしいですか？': 'Are you sure you want to delete row ({xx})?',
	'削除対象のデータがありません': 'Couldn\'t find the target data.',
	'部屋削除時にエラーが発生しました': 'An unexpected error has occurred. Issues with room data erasure.',
	// '{管理者メールアドレス}を削除します。よろしいですか？': 'Are you sure you want to delete "{管理者メールアドレス}"?',
	'管理者（{xx}行目）を削除します。よろしいですか？': 'Are you sure you want to delete row ({xx})?',
	'{phoneNumber}を削除します。よろしいですか？': 'Are you sure you want to delete "{phoneNumber}"? ',
	'アラート通知先電話番号（{xx}行目）を削除します。よろしいですか？': 'Are you sure you want to delete row ({xx})?',
	'アンケート画面作成': 'Survey Creation Page',
	
	'質問1': 'Question1',
	'質問2': 'Question2',
	'質問3': 'Question3',
	'回答1': 'Answer1',
	'回答2': 'Answer2',
	'回答3': 'Answer3',
	'" は入力できません。': '" cannot be entered.',
	'256文字以内で質問文を入力してください': 'Enter your answer in 256 characters or less.',
	'回答形式を選択してください': 'Select an answer form.',
	'Yes/No(ラジオボックス)': 'YES / NO (radio button)',
	'Yes/No/その他(ラジオボックス)': 'YES / NO / Other (radio button)',
	'1/2/3/4/5(ラジオボックス)': '1 / 2 / 3 / 4 / 5 (radio button)',
	'自由記述(テキスト)': 'Free Text',
	'店舗の管理者/副管理者に登録されているユーザに「店舗レポート」のメールを発行します。': 'Send email on "Report" to account holder and sub-account holder. ',
	'レポートダウンロード': 'Group Report Download',
	'年/月を指定して、過去の「店舗レポート」をダウンロードします。': 'Select the date of previous "Report" and download.',
	//  お知らせ管理.一覧
	
	'店舗/学校/病院情報': 'Store, School, Hospital Data',
	'公開／非公開': 'Public or Private',
	'公開中': 'Public',
	'非公開': 'Private',
	
	
	
	
	
	
	'一覧に戻る': 'Back to List',
	
	'お知らせID': 'Notice ID',
	'公開日': 'Publish Date',
	'タイトル': 'Title',
	'更新日': 'Update Date',
	
	
	'お知らせID={xx} を削除します。よろしいですか？': 'Are you sure you want to delete this Notice ID = {xx}?',
	'お知らせ情報が削除されました。': 'Deleted',
	
	'指定された店舗が管理対象店舗でないため検索・表示できません。': 'This property has not been registered. ',
	'お知らせ情報取得時にエラーが発生しました': 'An unexpected error has occurred. Issues with alert data acquisition.',
	
	'削除対象のお知らせ情報が存在しませんでした。': 'No data found',
	'お知らせ情報削除時にエラーが発生しました': 'An unexpected error has occurred. Issues with alert data erasure.',
	//  お知らせ管理.詳細
	'お知らせ情報の登録': 'Notice Data Registration',
	'お知らせ情報の更新': 'Notice Data Update',
	
	'公開開始日': 'Publish Date',
	'必須項目です。': 'Required field',
	'公開開始日は、2020年1月1日以降を設定してください。': 'Set a publish date on Jan 01, 2020 or later.',
	
	
	'お知らせ内容': 'Alert Content',
	'必須項目です。500文字以内で入力してください。': 'Required field. Enter 500 characters or less.',
	
	
	
	'お知らせ情報が登録されました。': 'Registration Successful',
	'お知らせ情報が更新されました。': 'Update Successful',
	
	
	'取得できるお知らせ情報がありません': 'No data found',
	'お知らせ詳細情報取得時にエラーが発生しました': 'An unexpected error has occurred. Issues with alert data acquisition.',
	
	'お知らせ情報登録時にエラーが発生しました': 'An unexpected error has occurred. Issues with alert data registration.',
	
	'更新対象のお知らせ情報が存在しませんでした。': 'No data found',
	'お知らせ情報更新時にエラーが発生しました': 'An unexpected error has occurred. Issues with alert data update.',
	
	
	
	//  アンケート結果管理.一覧
	
	
	'年：': 'Year:',
	'月：': 'Month:',
	'2021年': '2021',
	'2022年': '2022',
	'2023年': '2023',
	'2024年': '2024',
	'2025年': '2025',
	'2026年': '2026',
	'2027年': '2027',
	'2028年': '2028',
	'2029年': '2029',
	'2030年': '2030',
	'2031年': '2031',
	'2032年': '2032',
	'1月': 'Jan ',
	'2月': 'Feb',
	'3月': 'Mar',
	'4月': 'Apr',
	'5月': 'May ',
	'6月': 'Jun ',
	'7月': 'Jul ',
	'8月': 'Aug ',
	'9月': 'Sep ',
	'10月': 'Oct',
	'11月': 'Nov ',
	'12月': 'Dec ',
	
	'一覧再読み込み': 'Reload the list',
	
	
	
	
	
	'データ年月': 'Output Period',
	
	
	
	'ダウンロード可能': 'Downloadable',
	'出力中': 'Processing…',
	'該当データなし': 'No data found',
	'出力エラー': 'Output Error',
	
	'アンケート回答年月情報取得時にエラーが発生しました。': 'An unexpected error has occurred. Issues with answer date acquisition.',
	'該当データが存在しません。': 'No data found',
	
	
	//  店舗/学校/病院確認一覧
	
	'グループを選択してください': 'Select a group name',
	'必須項目です。対象のグループを選択してください。': 'Required field. Select a group.',
	'検索': 'Search',
	
	
	
	'下記、店舗/学校/病院記載内容の確認が出来ましたら、確認ボタンをクリックしてください。': 'Enter required data and click the "Confirm" button.',
	
	'確認を行いましたら、以下「確認」ボタンをクリックしてください。': 'Check entered data and click the "Confirm" button.',
	'確認': 'Confirm',
	'{店舗名}の情報を確認登録します。よろしいですか？': 'Continue to Register "{shopName}"?',
	
	'店舗/学校/病院情報が確認登録されました。': 'Registration Successful',
	
	'ユーザ情報が登録されていません。': 'The user data has not been registered. ',
	'利用権限がありません。': 'You are not authorized.',
	'管理者アドレスがユーザ情報として2件以上登録されています。システム管理者にご連絡ください。': 'Two or more addresses exist. Please contact your system administrator.',
	'店舗確認登録時にエラーが発生しました': 'An unexpected error has occurred. Issues with property data registration.',
	
	'確認可能な店舗/学校/病院が存在しません。': 'No data found',
	'店舗確認一覧取得時にエラーが発生しました': 'An unexpected error has occurred. Issues with property confirmation data acquisition.',
	
	//  センサー管理
	'店舗編集画面へ': 'Go to Store Edit page',
	'対象 店舗/学校/病院 設定': 'Store, School, Hospital Settings',
	'検索候補がありません': 'Couldn\'t find any matches for your search.',
	'店舗/学校/病院を選択してください': 'Select Store, School, Hospital ',
	
	'設定': 'Settings ',
	'センサー登録': 'Sensor Registration',
	'紐づけ店舗/学校/病院 部屋': 'Linked Store, School, Hospital Room',
	'店舗/学校/病院 部屋を選択してください': 'Select Store, School, Hospital Room',
	
	'センサーＩＤ': 'Sensor ID',
	'必須項目です。センサーＩＤを入力してください。': 'Required field. Enter sensor ID.',
	
	'※お手元のセンサーの登録操作をした後、30分以内にセンサーIDを登録してください。': 'Register sensor ID no later than 30minutes after your sensor registration operation.',
	'登録済みセンサー一覧': 'Registered Sensor List ',
	
	'詳細確認': 'View more details',
	
	'店舗/学校/病院 部屋名': 'Store, School, Hospital Room Name ',
	'代表センサー': 'Main Sensor ',
	'センサーID': 'Sensor ID',
	'センサー名': 'Sensor Name',
	
	'登録解除': 'Deregistration',
	'センサーID : {sensorId}の登録を解除します。よろしいですか？': 'Are you sure you want to delete ({sensorId})?',
	'データ取得時にエラーが発生しました。': 'An unexpected error has occurred. Issues with Retrieving Data.',
	
	
	
	
	
	'センサーへの紐づけ登録ができません。センサー端末画面で「Registration」をクリックしてください。': 'Failed to connect the sensor. Click "Registration" button on the sensor.',
	'他の店舗・学校・病院で代表センサーとなっているため、対象センサーの紐づけ解除後に再度登録を実施してください。': 'The sensor is already registered as a main. Try registration again after deregistration.',
	'店舗・学校・病院のセンサーの登録を先に行ってください。': 'Registering sensors is needed first.',
	'センサー紐づけ登録時にエラーが発生しました': 'An unexpected error has occurred. Issues with connecting sensor.',
	
	
	'代表センサーを削除することはできません。他のセンサーに代表センサーに変更した後、再度実施してください。': 'The main sensor cannot be deleted. Change the main sensor to another sensor and then try delete it again.',
	'センサー紐づけ解除時にエラーが発生しました': 'An unexpected error has occurred.　Issues with deregistration of connected sensors.',
	//  センサー管理.公開設定
	'センサー設定': 'Sensor Settings',
	'代表センサーに設定する': 'Main Sensor Settings',
	
	'20文字以内で入力してください。': 'Enter 20 characters or less.',
	'センサー名（英語）': 'Sensor Name (English)',
	
	'公開センサー選択': 'Select Public Sensor ',
	'設定の反映には最大5分間かかります。': 'The change will be reflected in 5 minutes.',
	'CO2濃度を公開する': 'Publish CO2 Concentration',
	'室温を公開する': 'Publish Room Temperature',
	'湿度を公開する': 'Publish Humidity',
	'騒音を公開する': 'Publish Noise',
	'混雑指数を公開する': 'Publish Congestion Index',
	'暑さ指数を公開する': 'Publish WBGT',
	'アラート設定': 'Alert Settings ',
	'通知先及び通知方法の設定は店舗管理画面で行ってください。': 'You can set alert recipients and methods on the store management screen.',
	'基準値を15分以上超えた場合、アラート設定先に対して通知が送信されます。': 'The recipient will receive alert if the standard value is exceeded for more than 15 minutes.',
	'CO2濃度のアラートを通知する': 'Notify CO2 Concentration Alert',
	'通知基準値': 'Alert Criteria',
	'4桁以内の数字で入力してください。': 'Enter 4 digits or less.',
	'ppm 以上': '     ppm or more ',
	'室温のアラートを通知する': 'Notify Room Temperature Alert',
	
	'3桁以内の数字で入力してください。': 'Enter 3 digits or less.',
	'℃以上': '      degrees or more',
	'℃以下': '      degrees or less',
	'湿度のアラートを通知する': 'Notify Humidity Alert',
	
	
	'％以上': '     % or more ',
	'％以下': '     % or less',
	'騒音のアラートを通知する': 'Notify Noise Alert',
	
	
	'dB以上': '     db or more',
	'混雑指数のアラートを通知する': 'Publish Congestion Index Alert ',
	'暑さ指数のアラートを通知する': 'Notify WBGT alerts',
	
	
	
	
	
	'センサー情報が更新されました。': 'Update Successful',
	'センサー情報が存在しません': 'No data found',
	
	'指定されたセンサの紐づけ店舗が管理対象店舗でないため表示できません。': 'You are not authorized.',
	'センサー詳細情報を取得できませんでした': 'Couldn\'t get the data.',
	'センサー設定情報取得時にエラーが発生しました': 'An unexpected error has occurred. Issues with sensor setting data acquisition.',
	
	'代表センサーは店舗・学校・病院にのみ設定可能です。': 'Main sensor can be set only for Store, School, Hospital.',
	'代表センサーには公開中のセンサーを選択してください。': 'Select a main sensor from public sensors.',
	'代表センサーを非公開にすることはできません。公開設定を行ってください。': 'The main sensor cannot be private. Set it as public.',
	'代表センサーを公開した後、再度実施してください。': 'Tray again after releasing the main sensor.',
	'センサー公開設定にてエラーが発生しました': 'An unexpected error has occurred. Issues with releasing sensor.',
	'公開センサー選択でチェックしている場合、以下のアラート設定にて、「通知する」にチェックをお勧めします。': 'If you have checked the box for public sensor selection, we recommend that you check the "Notify" box in the alert settings below.',

	//  センサー管理.詳細確認
	'センサー詳細情報': 'Sensor detail',
	
	
	
	
	
	
	
	
	
	
	
	
	'現在の状況': 'Current State',
	'CO2濃度': 'CO2 Concentration',
	'室温': 'Room Temperature',
	'湿度': 'Humidity',
	'騒音': 'Noise',
	'混雑指数': 'Congestion Index',
	
	'指定されたセンサーの紐づけ店舗が管理対象店舗でないため表示できません。': 'This property is not registered. ',
	'センサー情報が登録されていません。': 'The sensor data has not been registered. ',
	'センサー詳細情報取得時にエラーが発生しました': 'An unexpected error has occurred. Issues with sensor detail acquisition.',
	'グラフ情報はまだ生成されていません。時間をおいて再度参照してください。': 'The chart data has not been obtained. Please try again later. ',
	//  センサーデータダウンロード
	
	
	
	
	
	'（全て）': '(All)',
	
	
	'データ開始日': 'Data Starts',
	
	'データ終了日': 'Data Ends',
	
	'※最大90日分です。': '*Up to 90 days',
	'クイック入力': 'Quick Entry',
	'最新10日分': 'Last 10 days',
	'最新30日分': 'Last 30 days',
	'最新90日分': 'Last 90 days',
	'出力予約': 'Scheduled output',
	'一覧を再読み込み': 'Reload the list',
	'ダウンロード可能期限は1週間です。出力日から1週間後に一覧から削除されます。': 'Downloads are available for one week. The data will be delated from the list one week after the output date.',
	'ダウンロード': 'Download',
	'ステータス': 'Status',
	'出力日時': 'Output Date and Time',
	
	
	
	
	'履歴削除': 'Clear History',
	'選択された期間が90日を超えています。期間は90日以内で選択してください。': 'The period you selected is longer than 90 days. Select again a period within 90 days.',
	'選択された開始日が終了日よりも未来となっています。': 'The start date is future than the end date.',
	'ダウンロードに失敗しました': 'Download failed',
	'該当データがありません': 'No data found',
	'ダウンロード時にエラーが発生しました': 'An unexpected error has occurred. Issues with downloading.',
	'履歴を削除します。よろしいですか？': 'Are you sure you want to delete the history?',
	'センサーデータダウンロード時にエラーが発生しました': 'An unexpected error has occurred. Issues with downloading sensor data.',
	'管理情報に基づく店舗一覧取得時にエラーが発生しました': 'An unexpected error has occurred. Issues with property management data acquisition.',
	
	'ダウンロード情報取得時にエラーが発生しました': 'An unexpected error has occurred. Issues with download information acquisition.',
	'ダウンロード情報登録時にエラーが発生しました': 'An unexpected error has occurred. Issues with download information registration.',
	'センサーデータ削除時にエラーが発生しました': 'An unexpected error has occurred. Issues with sensor data erasure.',
	//  セキュリティ情報管理.一覧
	
	
	
	
	
	
	
	'ユーザー一覧': 'User List',
	
	
	
	
	
	
	
	
	
	//  セキュリティ情報管理.詳細
	'セキュリティ情報の更新': 'Security Data Update',
	'店舗/学校/病院 セキュリティ設定': 'Store, School, Hospital Security Settings',
	'管理ユーザー(セキュリティ設定にかかわらず参照可能）': 'Account Holder (can be viewed regardless of security settings)',
	'セキュリティコード': 'Security Code',
	'セキュリティコードは、半角8文字以上12文字以内の文字列で、英大文字・英小文字・数字それぞれを最低1文字ずつ含む必要があります。': 'Use strong security codes that contain between 8 and 12 characters and combine at least one upper- and lowercase letters, numbers.',
	'・使用できる文字は、半角英字（大文字・小文字）・半角の数字です。': 'The characters that can be used are single-byte letters (upper and lower case) and single-byte numbers.',
	'・英大文字・英小文字・数字それぞれを最低1文字ずつ含む必要があります。': 'Security codes must contain at least one uppercase letter, one lowercase letter, and one number.',
	'・長さは、半角8文字以上 半角12文字以下です。': 'Security codes that must contain between 8 and 12 characters.',
	'管理ユーザー登録': 'Account Holder Registration ',
	'管理ユーザー一括削除': 'Delete All Account Holders',
	'ユーザー全削除': 'Delete All Users',
	'{店舗名}の管理ユーザーのユーザー削除 を行います。よろしいですか？': 'Are you sure you want to delete the administratal user of {shopName}?',
	'{店舗名}の管理者以外のユーザー削除 を行います。よろしいですか？': 'Are you sure you want to delete users other than the administrator of {shopName}?',
	'店舗/学校/病院設定': 'Store, School, Hospital Settings',
	
	'セキュリティ設定': 'Security Settings',
	'フリー公開': 'Public',
	'ユーザー公開': 'Publish to User',
	'特定ユーザー公開': 'Publish to Specific User',
	
	'ユーザー登録': 'User Registration ',
	'ユーザー一括削除': 'Delete',
	'部屋別セキュリティ一覧': 'Security List per room ',
	
	
	
	
	'店舗/学校/病院の設定がフリー公開の場合のみ、部屋をフリー公開に設定することが可能です。': 'You can set a room as Public only if Store, School, Hospital Settings is set as Public.',
	'ユーザー公開の設定がいずれかにある場合には、特定ユーザー公開の設定が必須です。': 'Publish to Specific User setting is required. ',
	'特定ユーザー公開の場合、セキュリティコードは必須です。': 'Security Code is required when specific user is set as Public.',
	'特定ユーザー公開以外の場合、セキュリティコードは不要です。': 'Security Code is not required when user(s) is set as Public.',
	// '特定ユーザー公開の場合、セキュリティコードは必須です。 対象：{部屋名}': 'Security Code is required when specific user is set as Public. Destination:"{店舗名}"',
	// '特定ユーザー公開以外の場合、セキュリティコードは不要です。 対象：{部屋名}': 'Security Code is not required when user(s) is set as Public. Destination:"{店舗名}"',
	'管理者セキュリティコードは入力必須です。': 'Security Code is required. ',
	
	'セキュリティ詳細情報取得時にエラーが発生しました': 'An unexpected error has occurred. Issues with security data acquisition.',
	'セキュリティ情報更新時にエラーが発生しました': 'An unexpected error has occurred. Issues with security data update.',
	'{店舗名}のユーザー削除 を行います。よろしいですか？': 'Are you sure you want to delete this user {shopName}?',
	'削除が完了しました。': 'Deleted',
	'セキュリティユーザー削除時にエラーが発生しました。': 'An unexpected error has occurred. Issues with security data erasure.',
	'対象：': 'Destination:',
	//  
	//  セキュリティ情報管理.ユーザー一覧
	
	
	'メールアドレス': 'Email address',
	
	
	
	'店舗/学校/病院/部屋': 'Store, School, Hospital, Room',
	'管理ユーザー': 'Account holder',
	
	'管理対象店舗でないため表示できません。': 'This property is not registered. ',
	'セキュリティユーザー一覧取得時にエラーが発生しました': 'An unexpected error has occurred. Issues with security user data list acquisition.',
	'{メールアドレス} のユーザー削除 を行います。よろしいですか？': 'Are you sure you want to delete {mailAddress}?',
	
	
	
	//  グラフ埋め込み用HTML出力.一覧
	
	
	'コード表示/プレビュー': 'View code / Preview',
	
	'出力ID': 'Output ID',
	
	'形式': 'Property Name',
	'登録名': 'Registered Name',
	'更新日時': 'Update Date',
	
	'埋め込みHTML設定情報一覧取得時にエラーが発生しました': 'An unexpected error has occurred. Issues with embedded HTML setting data acquisition.',
	'{出力ID　登録名} を削除します。よろしいですか？': 'Are you sure you want to delete "{embeddedId} {registerName}"?',
	'埋め込みHTML設定情報削除時にエラーが発生しました': 'An unexpected error has occurred. Issues with embedded HTML setting data erasure.',
	'埋め込み情報が削除されました。': 'Deleted ',
	//  グラフ埋め込み用HTML出力.コード表示・プレビュー
	'タグ': 'Tag',
	//  グラフ埋め込み用HTML出力.詳細
	
	
	'店舗/学校/病院名を選択してください。': 'Select name of Store, School, Hospital.',
	
	'表示形式': 'Display format',
	'表示形式を選択してください': 'Select Format',
	'横幅可変(300px以上）、複数種類センサー、単一場所（端末）': 'Variable width (300px or more), multiple types of sensors, single location (terminal)',
	'横幅可変(200px～300px）、単一種類センサー、複数場所（端末）': 'Variable width (200px to 300px), single type sensor, multiple locations (terminals)',
	'縦横幅固定(300px×250px)、2種類センサー、単一場所（端末）': 'Fixed height and width (300px x 250px), two types of sensors, single location (terminal)',
	
	
	'グラフ埋め込み情報': 'Embedded Chart Data',
	'埋め込みID': 'Embedded ID',
	
	
	
	
	
	'公開する': 'Public',
	
	'端末一覧': 'Sensors List ',
	'公開/非公開': 'Public / Private',
	
	
	
	
	
	
	'選択した「表示形式」の場合、「表示項目」で選択された個数は、指定できません。１～5個選択可能です。': 'In this "Display Format", the maximum number of selected items is 6. Select the items again.',
	'選択した「表示形式」の場合、「表示項目」で選択された個数は、指定できません。１個選択可能です。': 'In this "Display Format", the maximum number of selected items is 1. Select the item again.',
	'選択した「表示形式」の場合、「表示項目」で選択された個数は、指定できません。１～２個選択可能です。': 'The number of selected items exceeds the limit, select again between 1 and two items.',
	'「端末一覧」にて、非公開または削除されたセンサーIDが選択されています。現在公開されているセンサーIDを選択してください。対象：': 'A sensor that is private or deleted in the sensor list has been selected. Select a public sensor again. Destination:',
	'「端末一覧」が未選択です。センサーIDを選択してください。': 'The Sensor List has not been selected. Select Sensor ID.',
	'公開可能なセンサーは最大5個です。公開センサーを再選択してください。': 'The maximum number of public sensors is 5. Select the public sensors again.',
	'選択した「表示形式」の場合、「端末一覧」で選択された個数は、指定できません。１個のみ選択可能です。': 'In this Display Format, the maximum number of selected items is 1. Select the item again.',
	'※ 表示対象のセンサーID（表示順で表示）': 'Public Sensor ID (display in order)',
	'表示項目': 'Display Item',
	
	
	
	
	
	'埋め込み設定 表示カラー': 'Embedding Settings Display Color ',
	'ライト': 'Light ',
	'ダーク': 'Dark',
	'公開対象のセンサーには、アラート設定をすることを推奨します。': 'Alert settings is recommended to the public sensors.',
	'アラート設定：指定した基準値を15分以上超えた場合、アラート通知先に対して通知が送信されます。': 'Alert Settings: a recipient will receive alert if the value exceeds the standard value for more than 15 minutes.',
	'設定方法は、「センサー登録」の公開設定にて、基準値及び通知項目の指定、「店舗/学校/病院情報管理」の「アラート通知設定」にて通知方法、通知先の設定が出来ます。': 'Standard Value and Alert items can be set at Public Settings of Sensor Registration. Alert Methods and Recipients can be set at "Alert Settings" of "Property Management".',
	
	
	
	
	'HTML出力可能なセンサーIDが見つかりません。センサー登録画面にて公開を行ってください。': 'Couldn`t find a sensor ID that can be output in HTML. Publish sensors on the Sensor Registration screen.',
	
	'埋め込みHTML設定情報がありません': 'No data found',
	'埋め込みHTML設定情報取得時にエラーが発生しました': 'An unexpected error has occurred. Issues with embedded HTML setting data acquisition.',
	
	
	
	'管理者でないため登録できません。': 'You are not authorized to use this function.',
	'埋め込みHTML設定情報登録時にエラーが発生しました': 'An unexpected error has occurred. Issues with embedded HTML setting data registration.',
	
	
	
	
	'グラフ埋め込み情報が登録されました。': 'Registration Successful',
	//  ユーザー情報管理.一覧
	
	
	
	
	'権限': 'Authority',
	'会社名': 'Company Name',
	'部署名': 'Department ',
	'ユーザーID': 'User ID',
	
	'{ユーザーID} を削除します。よろしいですか？': 'Are you sure you want to delete {userID} ?',
	
	'ユーザ情報取得時にエラーが発生しました': 'An unexpected error has occurred. Issues with user data acquisition.',
	
	'施設もしくは店舗の代表管理者となってるため削除できません。': 'You are not authorized to use this function.',
	'ユーザ情報削除時にエラーが発生しました': 'An unexpected error has occurred. Issues with user data erasure.',
	'ユーザー情報が削除されました。': 'Deleted',
	//  ユーザー情報管理.詳細
	'ユーザー情報の更新': 'User Data Update',
	'ユーザー情報の登録': 'User Data Registration',
	
	
	'EMAILアドレスの書式で、256文字以内で入力してください。': 'Enter by email address style, using 256 characters or less.',
	
	'必須項目です。対象の権限を選択してください。': 'Required field. Select one authority.',
	
	
	
	
	
	'ユーザー情報が登録されました。': 'Registration Successful',
	'ユーザー情報が更新されました。': 'Updated Successful',
	
	'ユーザー詳細取得時にエラーが発生しました': 'An unexpected error has occurred. Issues with user data detail acquisition.',
	'すでに登録されているメールアドレスのため登録できません': 'Couldn\'t register. This email address is already registered.',
	'ユーザ情報登録時にエラーが発生しました': 'An unexpected error has occurred. Issues with user data registration.',
	'すでに登録されているメールアドレスのため更新できません': 'Couldn\'t update. This email address is already registered.',
	'ユーザ情報更新時にエラーが発生しました': 'An unexpected error has occurred. Issues with user data update.',
	//  メニュー
	'ユーザ権限取得時にエラーが発生しました': 'An unexpected error has occurred. Issues with user authority settings.',
	//  マニュアル/FAQ
	'マニュアル': 'Manual',
	'操作マニュアル': 'Screen item manual',
	'簡易マニュアル': 'Operation manual',
	'FAQ': 'FAQ',
	//  利用規約
	//  
	//  
	//  ログイン
	'ログイン': 'Login',
	'登録済みのメールアドレスとパスワードを入力し、ログインしてください。': 'Login with the registered email address and password.',
	
	'パスワード': 'Password',
	
	'パスワードを忘れた方はこちら': 'Forget your password?',
	
	'初めて利用する方': 'Not registered yet? Register here',
	'おみせのトラストを初めて利用する方は、ユーザー登録が必要です。': '',
	'以下のユーザー登録ボタンを押して、メールアドレスとパスワードを設定してください。': '',
	
	'メールアドレスまたは、パスワードを確認してください。': 'The password or email address did not work. Please try again.',
	//  ユーザー登録.利用規約
	'本HPのご利用前に、以下利用規約（アンカーリンク）をご確認ください。': 'Please carefully read <a href="#termOfService">the Terms of Service</a> before using our website.',
	'ご利用開始した時点で利用規約に同意したものとみなします。': 'Your registration on this website will constitute your acceptance of the Terms of Service.',
	'本HP「おみせのトラスト」は、お店のトラスト情報（信頼性情報）を見える化する実証実験です。': 'T*Plats visualizes data related to trustworthiness.',
	'ここでいうトラスト情報とは、以下にあるコロナ対策を実施してるかを証明し、 確認できるようにすることを目的としています。': 'Trust information of T*Plats is evidence that you carry out the following hygiene managements properly, which is accessible information by consumer.',
	'（※本実証実験は、内閣府が進める戦略的イノベーション想像プログラム（SIP)': '(*This demonstration experiment is part of SIP (Cross-ministerial Strategic Innovation Promotion Program), a national program of the Japanese Government.)  ',
	'「IoT社会に対応したサイバー・フィジカル・セキュリティ」': 'Cyber-Physical Security for IoT Society',
	'（管理法人_国立研究開発法人_新エネルギー_産業技術総合開発機構）によって実施されています。）': 'Management corporation:National Research and Development Corporation New Energy and Industrial Technology Development Organization',
	'利用規約に同意し、ユーザー登録へ進む。': 'Accept the Terms and Conditions, and go on to registration',
	
	// '原文を参照': '(english)原文を参照',
	//  ユーザー登録
	
	'登録するメールアドレスとパスワードを入力してください。': 'Enter your email address to register.',
	'ユーザー登録用の検証コードが送信されます。': 'A verification code will be sent.',
	'メールが受信できない場合は、「@trust-shop.hitachi.co.jp」のドメインを受信する設定にご変更ください。': 'If you cannot receive emails from T*Plats, please change your settings so you can receive emails from its domain, " @tplats.hitachi.co.jp".',
	'パスワードは、大文字、小文字、数字を含む、8桁以上の値を設定してください。': 'Your password must be more than 8 characters long, should contain at-least 1 Uppercase, 1 Lowercase, 1 Numeric.',
	
	
	'パスワード（確認）': 'Confirm Password',
	'検証コードを送信する': 'Get a verification code',
	'ログイン画面に戻る': 'Back to Login Page',
	'再ログインしてください。': 'Please login again',
	'メールアドレスが未登録です。管理者に問い合わせてください。': 'Couldn\'t find the address. Please contact your system administrator.',
	'すでにユーザーが登録されています。検証コードの入力が完了していない場合は、ログイン画面からログインし、ユーザー登録を完了してください。パスワードを忘れた場合は、ログイン画面からパスワード変更を行ってください。': 'This user is already registered. If you have not yet entered a verification code, login again and complete your registration. If you forgot your password, reset it on the login page.',
	
	'パスワードと、パスワード（確認）が一致しません。': 'The password and confirmation password do not much.',
	//  ユーザー登録完了
	'ユーザー登録の完了': 'Registration Successful',
	'{UserName}に検証用コードを送信しました。': 'A verification code has been sent to {UserName}.',
	'検証用コードを入力し、ユーザー登録を完了してください。': 'Enter the verification code mailed to you to complete your registration.',
	'検証コード': 'Verification Code',
	'ユーザー登録を完了する': 'Complete Registration',
	'検証コードを再送する': 'Get Code Again',
	'検証コードを確認してください。': 'The code did not work. Please try again.',
	//  パスワードリセット
	'パスワードリセット': 'Reset Password',
	'登録済みのメールアドレスを入力してください。': 'Couldn`t find an account with that email address.',
	'パスワード変更用の検証コードが送信されます。': 'A verification code to change password has been sent.',
	
	
	
	//  パスワード更新
	'パスワード更新': 'Update Password',
	
	
	
	
	'パスワード変更': 'Change Password',
	
	
	'新しいパスワードと、新しいパスワード（確認）が一致しません。': 'The new password and confirmation password do not much.',
	//  センサーデータダウンロード画面(追加分)
	'詳細条件': 'Detail',
	'データラベル': 'Data Label',
	'英語': 'English',
	'日本語': 'Japanese',
	'出力項目': 'Output Item',
	'出力するデータの種類': 'Type of Output Data',
	'環境データ': 'Environmental Data',
	'ブルートゥース詳細データ': 'Detail Bluetooth Data',
	'全選択': 'Select All',
	'全解除': 'Clear All',
	'共通項目：設置場所': 'Common Items：Installation Location',
	'共通項目：時間': 'Common Items：Time',
	'出力データ': 'Output Data',
	'データ加工なし': 'Do NOT Process Data',
	'データベースに格納されているデータ（1分毎）を出力します。': 'Get Stored Data from Database (every 1 minute)',
	'5分平均値': '5 minute average',
	'5分毎の平均値を出力します。': 'Get the average per 5 minutes',
	'10分平均値': '10 minute average',
	'10分毎の平均値を出力します。': 'Get the average per 10 minutes',
	'30分平均値': '30 minute average',
	'30分毎の平均値を出力します。': 'Get the average per 30 minutes',
	'1時間平均値': '1 hour average',
	'1時間毎の平均値を出力します。': 'Get the average per 1 hour',
	'詳細': 'Detail',
	'ダウンロード項目': 'Download Item',
	//重複しているのでコメントアウト
	// 'ダウンロード可能': '(english)ダウンロード可能',
	// '出力中': '(english)出力中',
	// '該当データなし': '(english)該当データなし',
	// '出力エラー': '(english)出力エラー',
	// '該当データが存在しません。': '(english)該当データが存在しません。',

	//  アラート通知機能メッセージ内容
	'検知日時': 'Detect Date and Time',
	'施設名': 'Property Name',
	'店舗名': 'Store Name ',
	
	'以下の計測項目が指定した基準値を超えています。': 'The following sensor exceeds the standard value.',
	'CO2': 'CO2',
	
	
	
	
	'計測値': 'Measured Value',
	'指定した基準値': 'Specified Standard Value',
	'ppm以上': 'ppm or more',
	'°C以上': '°C or more',
	'°C以下': '°C or less',
	'%以上': '% or more ',
	'%以下': '% or less',
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	'【おみせのトラスト】アラート通知': '【T*Plats】　Alert',
	
	
	'以下の計測項目が基準値を超えています。': 'The following sensor exceeds the standard value.',
	
	
	
	
	
	// センサー管理 センサー設定画面(追加分)
	//重複しているのでコメントアウト
	//'基準値を15分以上超えた場合、アラート設定先に対して通知が送信されます。': '(english)基準値を15分以上超えた場合、アラート設定先に対して通知が送信されます。',
	//  セキュリティ情報管理 ユーザー登録
	'ユーザ登録用QRコード表示': 'Get Registration QR Code',
	'登録用URL': 'Registration URL ',
	//  公開機能
	'場所を探す': 'Search Location',
	'よくある質問': 'Frequently Asked Questions / FAQ',
	'アンケート': 'Survey',
	'お客様満足度アンケート': 'Customer Survey',
	'いつもご利用いただき誠にありがとうございます。よりお客様にご満足いただけるサービスが提供できるよる、アンケートを行っております。ぜひご意見をお聞かせください': 'Thank you for using our services. We are conducting this survey so that we can provide you with more satisfactory services. Please let us know your opinions!',
	'※　本アンケートは、各店舗の顧客満足度把握が目的です。個人情報の取得は行いませんので、ご入力はお控え下さい。各店舗への誹謗中傷はお控え下さい。': 'The purpose of this survey is to understand customer satisfaction at each store.Please do not enter your personal information as we will not obtain it.Please refrain from slandering or slandering specific organizations or individuals. ',
	'アンケートを送信する': 'Submit ',
	'はい': 'YES',
	'いいえ': 'NO',
	'その他': 'Other',
	'満足': 'Satisfied',
	'やや満足': 'Slightly satisfied',
	'どちらともいえない': 'Not sure',
	'やや不満': 'Slightly dissatisfied',
	'不満': 'Dissatisfied',
	'表示モード': 'Display Mode',
	'標準': 'Standard',
	'サイネージモード（タブレット）': 'Signage mode for the Tablet',
	'サイネージモード（スマホ）': 'Signage mode for the Smartphone',

	// 追加メニュー分
	'店舗/学校/病院情報管理 / お知らせ管理': 'Store, School, Hospital Management / Notice Management',
	'店舗/学校/病院情報管理 / アンケート結果': 'Store, School, Hospital Management / Survey Results',
	
	// センサーグラフ
	// CO2
	'換気が必要': 'Ventilation Required',
  'やや換気が必要': 'Slight Ventilation Required',
  'よい.CO2濃度': 'Good',
	// 室温
  '高い.室温': 'High',
  'よい.室温': 'Good',
  '低い.室温': 'Low',
	// 湿度
  '高い.湿度': 'High',
  'よい.湿度': 'Good',
  '乾燥している': 'Low',
	// 騒音
  '非常にうるさい': 'Very Noisy',
  'うるさい': 'Noisy',
  'ふつう': 'Normal',
  '静か': 'Quiet',
	// 混雑指数
	'混雑': 'Congested',
  'やや混雑': 'Slightly Crowded',
  'よい.混雑指数': 'Good',
	// 暑さ指数
	'暑さ指数': 'Wet Bulb Globe Temperature',
  '危険.暑さ指数': 'Extreme Threat',
  '厳重警戒.暑さ指数': 'High Threat',
  '警戒.暑さ指数': 'Moderate Threat',
  '注意.暑さ指数': 'Elevated Threat',
  'ほぼ安全.暑さ指数': 'Low Threat',

		// 追加
		'※入力された住所を、サイト内でGoogleMap表示しますので、入力後にプレビューボタンで誤りが無いかご確認ください。': 'The address you entered will be displayed on the site as a Google Maps, so please make sure there are no errors in the address by clicking the preview button.',
		'セキュリティ情報が更新されました。': 'Security data was updated. ',
	
		// 規約
		'SLA': 'SLA',
		'サービス仕様書': 'Service Specifications',

	// リセラー情報管理
	'選択中のリセラー': 'Selected reseller',
	'リセラーID': 'Reseller ID',
	'リセラー名': 'Reseller name',
	'確定': 'Confirmation',
	'切替': 'Switching',
	'{リセラーID} を削除します。よろしいですか？': 'Are you sure to delete {resellerId}?',
	'親リセラーID': 'Parent Reseller ID',
	'親リセラー名': 'Parent reseller name',
	'リセラー管理会社名': 'Reseller management company name',
	'管理者のメールアドレス': 'Admin email address',
	'副管理者のメールアドレス': 'Vice admin email address',
	'リセラー情報の登録': 'Register reseller information',
	'リセラー情報の更新': 'Updating reseller information',
	'リセラー情報が登録されました。': 'Your reseller information has been registered',
	'リセラー情報が更新されました。': 'Your reseller information has been updated',
	'リセラー情報が削除されました。': 'Your reseller information has been deleted',

	// リセラー選択
	'リセラー選択': 'Select reseller',
	'上位／下位': 'Upper/Lower',
	'リセラーを切り替える場合は、「リセラー選択」ボタンで選択し、「確定」ボタンを押してください。': 'To switch resellers, choose a reseller with "Select reseller" button and entre "Confirmation" button.',

	// 共通リセラーチェック処理
	'ユーザー権限取得時にエラーが発生しました。': 'An error occurred while acquiring user authority',
	'ユーザーのリセラー権限取得時にエラーが発生しました。': 'An error occurred while retrieving reseller privileges for the user',
	'参照・選択可能なリセラー情報がありません。': 'There is no reseller information that can be viewed/selected',

}
